import { render, staticRenderFns } from "./page-title-bg.vue?vue&type=template&id=538ce44a"
import script from "./page-title-bg.vue?vue&type=script&lang=js"
export * from "./page-title-bg.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./page-title-bg.vue?vue&type=style&index=0&id=538ce44a&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "b8ad551a"
  
)

export default component.exports